type LengthLike = { length: number };

export function isEmpty<T extends LengthLike | null | undefined>(
  value: T,
): boolean {
  if (!value) return true;

  if (
    typeof value === 'string' ||
    Array.isArray(value) ||
    (typeof value === 'object' && 'length' in value)
  )
    return value.length === 0;

  throw new Error('got unexpected value in isEmpty');
}

export function isNotEmpty<T extends LengthLike | null | undefined>(
  value: T,
): boolean {
  return !isEmpty(value);
}
